<template>
  <div class="container">
	<h1>H5唤醒微信小程序示例</h1>
	<wx-open-launch-weapp
		id="launch-btn"
		appid="wx5b0a13766039d37d"
		path="pages/index/index"
		@error="handleErrorFn"
		@launch="handleLaunchFn"
	>
	  <component :is="'script'" v-bind="{type:'text/wxtag-template'}">
		  <div class="btn">日照智慧停车小程序</div>
	  </component>
	</wx-open-launch-weapp>
  </div>
</template>

<script>
import { mixin } from '@/utils/mixin.js'
import weixin from '@/utils/weixinSDK.js'
export default {
	name: 'Demo',
	mixins:[mixin],
	props: ['id'],
	data () {
		return {
		  str:'234'
		}
	},
	methods: {
		wxConfig () {
			let url = location.href.split('#')[0]
			//weixin.initSign(url)
			console.log(url)
		},
		handleErrorFn(e) {
		   console.log('fail', e.detail);
		},
		handleLaunchFn(e) { 
		  console.log('success', e)
		}
	},
	created () {
		let url = location.href.split('#')[0]
		weixin.initSign(url)
	},
	mounted () {
	
	}
}
</script>

<style lang="less" scoped>
.container {
  height: 100vh;
  overflow: auto;
  background: #eee;
  padding: 15px;
  position: relative;
  
  .btn {
	  width: 100%;
	  height: 44px;
	  font-size: 22px;
	  background: #336699;
	  color: #fff;
	  border: 0;
  }
}
</style>
